import { createGRN } from "logic/permissions/GRN";
import useCurrentUser from "hooks/useCurrentUser";
import { hasAdminPermission } from "util/PermissionsMixin";
const useHasEntityOwnership = (id, type) => {
  const currentUser = useCurrentUser();
  if (!currentUser) {
    return false;
  }
  const { grnPermissions = [], permissions } = currentUser;
  return hasAdminPermission(permissions) || grnPermissions.includes(`entity:own:${createGRN(type, id)}`);
};
export default useHasEntityOwnership;
